const recentToasts = new Map<string, number>();

export function isDuplicateErrorToast(
  message: string,
  windowMs: number,
): boolean {
  const now = Date.now();
  const last = recentToasts.get(message);
  if (last !== undefined && now - last < windowMs) {
    return true;
  }
  recentToasts.set(message, now);
  return false;
}

export function _resetForTesting(): void {
  recentToasts.clear();
}
